const baseFitmentFields = ['Year', 'Make', 'Model', 'Submodel', 'Chassis'];
const extraFitmentFields = [];

const wheelsFields = ['wheel_tire_diameter', 'wheel_width', 'wheel_bolt_pattern', 'wheel_offset'];
const ignoreFields = [...wheelsFields];

window.Convermax.isLoggedIn = window.document.querySelector(
  '.navUser-item--account .navUser-action[href="/login.php?action=logout"]',
);

const blankCheckboxEl = document.querySelector('.hover-price-details .price-checkbox.blank_checkbox');
const mapPriceCheckboxEl = document.querySelector('.hover-price-details .price-checkbox.map_checkbox');
const msrpPriceCheckboxEl = document.querySelector('.hover-price-details .price-checkbox.msrp_checkbox');
const dealerPriceCheckboxEl = document.querySelector('.hover-price-details .price-checkbox.dealer_checkbox');

const updatePriceVisibility = (e, priceEl) => {
  const updatedDisplay = e.target.checked ? 'block' : 'none';

  if (window.location.pathname === '/pages/search/') {
    document.querySelectorAll(priceEl).forEach((el) => (el.style.display = updatedDisplay));

    if (updatedDisplay === 'block' && blankCheckboxEl?.checked) {
      blankCheckboxEl.checked = false;
    }
  }
};

const InitFunc = () => {
  // theme code doesn't work on our search page
  // so duplicate logic for price view panel
  if (window.location.pathname === '/pages/search/' && blankCheckboxEl) {
    blankCheckboxEl.addEventListener('change', (e) => {
      if (e.target.checked) {
        document
          .querySelectorAll('.hover-price-details .price-checkbox:not(.blank_checkbox):checked')
          .forEach((el) => el.click());
      }
    });
  }

  // change window.Convermax variable that items price will show with correct view
  // and if we on client page, duplicate logic for price view panel
  if (mapPriceCheckboxEl) {
    mapPriceCheckboxEl.addEventListener('change', (e) =>
      updatePriceVisibility(e, '.cm_SearchResult .map_price_oncheck'),
    );
  }

  if (msrpPriceCheckboxEl) {
    msrpPriceCheckboxEl.addEventListener('change', (e) =>
      updatePriceVisibility(e, '.cm_SearchResult .msrp_price_oncheck'),
    );
  }

  if (dealerPriceCheckboxEl) {
    dealerPriceCheckboxEl.addEventListener('change', (e) =>
      updatePriceVisibility(e, '.cm_SearchResult spark-product-card'),
    );
  }
};

export default {
  platform: 'bigcommerce',
  searchPageUrl: '/pages/search',
  InitFunc,
  sortFields: ['relevance', 'name', 'name:desc', 'price', 'price:desc'],
  SearchRequestDefaults: {
    pageSize: window.Convermax.config?.pageSize || 36,
  },
  pagination: {
    centralRange: 1,
    edgeRange: 1,
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [{ pathname: '/categories/', field: 'category' }],
  },
  facets: {
    rangedFacet: [
      { fields: ['wheel_frontspacing', 'wheel_backspacing', 'wheel_backspace'], step: '1/100' },
      { fields: ['wheel_load'], step: '10//1' },
      { fields: ['tire_load_index'], slider: { mode: 'LowerBound' } },
      { fields: ['wheel_bore'], step: '1/10//1', slider: { mode: 'LowerBound' } },
    ],
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: 'body .page',
      template: 'SearchPage',
      visibleIf: () =>
        document.querySelector('#product-listing-container') && window.location.pathname !== '/categories/',
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields: [...ignoreFields, 'wheel_tire_fitment'],
    },
    {
      name: 'FilterChips__mobile',
      type: 'FacetPanel',
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields,
      initCollapsed: true,
    },
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: wheelsFields,
    },
    {
      name: 'SearchResult',
    },
    {
      name: 'SearchHeader',
    },
    {
      name: 'SearchBox',
      location: {
        replace: '#quickSearch .form',
      },
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        insertAfter: 'header .header-logo',
        class: 'cm_desktop-hide',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'HomeVehicleWidget_tab',
      type: 'RequestPanel',
      location: { selector: '#cm-home-ymm', class: 'cm_vehicle-widget__home-wheeltiretab' },
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: baseFitmentFields,
    },
    {
      name: 'WheelPanel_tab',
      type: 'RequestPanel',
      location: { selector: '#cm-home-wheel', class: 'cm_vehicle-widget__home-wheeltiretab' },
      template: 'HomeWheelTireBar',
      selectFields: wheelsFields,
    },
    {
      name: 'HomeSearchBox_tab',
      type: 'SearchBox',
      location: { selector: '#cm-home-keyword', class: 'cm_vehicle-widget__home-keywordtab' },
      template: 'SearchBox',
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
      isVehicleSelectionIsolated: true,
      columnBreakpoint: 650,
    },
    {
      name: 'VehicleInfo',
      initCollapsed: true,
    },
    {
      name: 'Garage',
      location: {
        insertBefore: 'header .navPages-container .navUser-item--account',
        class: `cm_mobile-hide${window.Convermax.isLoggedIn ? '' : ' cm_garage__no-auth'}`,
        wrapper: 'li',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'GarageMobile',
      type: 'Garage',
      location: {
        insertAfter: 'header .header-logo',
        class: 'cm_desktop-hide',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'VerifyFitment',
      location: {
        insertBefore: '.productView .productView-product .map_price_oncheck',
      },
      template: 'fitmentSearch/verifyFitment',
      columnBreakpoint: 600,
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: {
        selector: 'body .page',
        class: 'cm_vehicle-categories__category',
      },
      template: 'facetTiles/hierarchicalContainer',
      columnBreakpoint: 500,
      visibleIf: () => window.location.pathname === '/categories/',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
    },
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: ['wheel_tire_diameter'],
      showAllAlways: true,
      disableCollapse: true,
    },
    {
      name: 'WheelTireVehicleInfo',
      initCollapsed: true,
      useAutoSyncVisualizer: true,
    },
    {
      name: 'AutoSyncVisualizationDialog',
      template: 'fitmentSearch/autoSyncVisualizationDialog',
    },
  ],
};
